import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export default function ActionTabs({ changeActionTabStatus, tabStatus }) {
  const handleChange = (event, newValue) => {
    changeActionTabStatus(newValue);
  };

  return (
    <BoxWithMarginBottom>
      <Tabs
        value={tabStatus}
        onChange={handleChange}
        variant="fullWidth"
        textColor="inherit"
      >
        <Tab label="Open" data-qa="CP-Tab-Open-Actions" />
        <Tab label="Closed" data-qa="CP-Tab-Closed-Actions" />
      </Tabs>
    </BoxWithMarginBottom>
  );
}

ActionTabs.propTypes = {
  changeActionTabStatus: PropTypes.func,
  tabStatus: PropTypes.number
};

const BoxWithMarginBottom = styled(Box)`
  margin-bottom: 20px;
`;
